import { render, staticRenderFns } from "./forgot-password-page.vue?vue&type=template&id=2495fdd4"
import script from "./forgot-password-page.vue?vue&type=script&lang=js"
export * from "./forgot-password-page.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-page.vue?vue&type=style&index=0&id=2495fdd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports